import { gql } from '@apollo/client';

export const ALL_FUNDER_INTERVENTIONS = gql`
  query AllFunderInterventions($input: ExportArgs) {
    interventions: funderInterventions(input: $input) {
      id
      name
      fromDate
      toDate
      grades {
        id
        value
      }
      programme {
        id
        name
      }
      institutions {
        id
        institution {
          id
          name
        }
      }
      beneficiaryCount
      fromDate
      toDate
      beneficiaries {
        id
        name
      }
      otherBeneficiaries {
        id
        name
      }
      otherTreatmentGroups {
        id
        name
      }
      treatmentGroup {
        id
        name
      }
    }
  }
`;
